import React from "react";
import { useParams, useLocation } from "react-router-dom";

export default function VideoDetail() {
  const location = useLocation();
  const { videoId } = useParams();

  return (
    <>
      <h1>{location.state.videoSnippet.title}</h1>
      <iframe
        title="Youtube Video"
        width="70%"
        height="592"
        src={`https://www.youtube.com/embed/${videoId}`}
      ></iframe>
      <div className="">
        {location.state.videoSnippet.publishedAt.substr(0, 10)}
      </div>
      <div className="">{location.state.videoSnippet.description}</div>
    </>
  );
}
